import React, { useRef } from 'react';
import { noop } from 'lodash';
import { string, func } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { s_play_circle } from '@fiverr-private/icons';
import { Icon } from '@fiverr-private/fit';
import VideoModal from '../../../shared/VideoModal';
import { BIGQUERY_PAGE_NAME, MIXPANEL_PAGE_NAME } from '../../../../utils/biEvents/constants';

import './style.scss';

const sourceInfo = {
    videoName: 'Campaign video',
    mixpanel: {
        pageName: MIXPANEL_PAGE_NAME
    },
    bigQuery: {
        pageName: BIGQUERY_PAGE_NAME
    }
};

const VideoPreview = ({
    videoUrl,
    previewImgUrl,
    previewVideoUrl,
    titleTextKey,
    onPreviewClick = noop,
    onVideoOpen = noop,
    onVideoClose = noop
}) => {
    const videoPreviewRef = useRef(null);

    const onVideoPreviewClick = () => {
        videoPreviewRef.current && videoPreviewRef.current.pause();

        onPreviewClick();
    };

    const onVideoModalClose = () => {
        videoPreviewRef.current && videoPreviewRef.current.play();

        onVideoClose();
    };

    const trigger = ({ open }) => (
        <div className="video-preview">
            <div className="video-campaign-container"
                onClick={() => {
                    onVideoPreviewClick();
                    open();
                }}>
                <video className="preview-video-button"
                    ref={videoPreviewRef}
                    autoPlay muted loop playsInline
                    poster={previewImgUrl}>
                    <source src={previewVideoUrl} type="video/mp4"/>
                </video>
                <div className="video-button-gradiant"/>
                <div className="video-overlay">
                    {
                        titleTextKey &&
                        <h5>
                            <I18n k={titleTextKey}/>
                        </h5>
                    }
                    <Icon className="video-preview-icon" size={null} color="white">
                        {s_play_circle}
                    </Icon>
                </div>
            </div>
        </div>
    );

    return (
        <VideoModal videoUrl={videoUrl}
            onOpen={onVideoOpen}
            onClose={onVideoModalClose}
            trigger={trigger}
            sourceInfo={sourceInfo}/>
    );
};

VideoPreview.propTypes = {
    videoUrl: string,
    previewImgUrl: string,
    previewVideoUrl: string,
    titleTextKey: string,
    onPreviewClick: func,
    onVideoOpen: func,
    onVideoClose: func
};

export default VideoPreview;
